import { Flex, Heading, Text } from '@chakra-ui/react';
import React from 'react';

const PriceHeader = ({ summaryPrice, month }: { summaryPrice: number; month: string }) => (
  <Flex
    alignItems='center'
    gap='xs'
    justifyContent='center'
  >
    <Heading
      color='typography.pure'
      size='4xl'
    >
      ${summaryPrice}
    </Heading>

    <Text
      color='typography.pure'
      fontSize='lg'
      fontWeight='semibold'
    >
      {month}
    </Text>
  </Flex>
);

export default PriceHeader;
